"use strict";

jQuery(document).ready(function ($) {
  // Function to initialize the intersection observer
  function initIntersectionObserverStatsBlock() {
    var counterBlock = document.querySelectorAll('.count');
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          $(entry.target).prop("counter", 0).delay(500).animate({
            counter: $(entry.target).data('number')
          }, {
            duration: 1000,
            easing: "swing",
            step: function step(now) {
              now = Number(Math.ceil(now)).toLocaleString('en');
              $(this).text(now).delay(1000);
            }
          });
          observer.unobserve(entry.target);
        }
      });
    }, {
      root: null,
      // observing with respect to the viewport
      rootMargin: '0px',
      threshold: 0.1 // callback is executed when 10% of the target is visible
    });
    counterBlock.forEach(function (counterBlock) {
      return observer.observe(counterBlock);
    });
  }

  // Call the function to initialize the observer
  initIntersectionObserverStatsBlock();

  // MutationObserver to watch for changes in the DOM
  var domObserver = new MutationObserver(function (mutations, obs) {
    var counterBlock = document.querySelectorAll('.count');
    if (counterBlock.length > 0) {
      initIntersectionObserverStatsBlock(); // Reinitialize the observer for new elements
      obs.disconnect();
    }
  });

  // Start observing the body for child additions or subtree modifications
  domObserver.observe(document.body, {
    childList: true,
    subtree: true
  });

  // if ($('.stats-container').length) {
  //   var counter = document.querySelectorAll('.count');
  //   if ('IntersectionObserver' in window) {
  //     var handleIntersectionCounter = function handleIntersectionCounter(entries) {
  //       entries.map(function (entry) {
  //         if (entry.isIntersecting) {
  //           $(entry.target).prop("Counter", 0).delay(500).animate({
  //             Counter: $(entry.target).data('number')
  //           }, {
  //             duration: 1000,
  //             easing: "swing",
  //             step: function step(now) {
  //               now = Number(Math.ceil(now)).toLocaleString('en');
  //               $(this).text(now).delay(1000);
  //             }
  //           });
  //           observer.unobserve(entry.target);
  //         }
  //       });
  //     };
  //     var observer = new IntersectionObserver(handleIntersectionCounter);
  //     counter.forEach(function (counter) {
  //       return observer.observe(counter);
  //     });
  //   } else {
  //     console.log('Please use a modern browser!');
  //   }
  // }
});